<template>
    <div>

        <!-- @see https://vuejs.org/v2/guide/components.html#Dynamic-Components -->
        <component v-bind:is="chapterIconComponent"></component>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import defaultChapterIcon_svg from "../../../common/components/svg/chapter/defaultChapterIcon_svg.vue";

    const DEFAULT_CHAPTER_ICON = "defaultChapterIcon_svg"; // Component name of the default chapter icon (used if chapter-specific icon component can not be found).

    export default {
        name: 'ChapterIcon',
        components: {
            defaultChapterIcon_svg
        },

        props: {
            image: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                chapterIconComponent: DEFAULT_CHAPTER_ICON // default chapter icon
            }
        },

        mounted() {
            let svgComponentName = this.image.replace(".", "_");

            try {
                this.$options.components[svgComponentName] = require("../../../common/components/svg/chapter/" + svgComponentName + ".vue").default;
                this.chapterIconComponent = svgComponentName;
            }
            catch (error) {
                this.chapterIconComponent = DEFAULT_CHAPTER_ICON;
            }
        },
        watch: {
            image(newVal, oldVal){
                 if(newVal !== oldVal) {
                    let svgComponentName = newVal.replace(".", "_");
                    this.$options.components[svgComponentName] = require("../../../common/components/svg/chapter/" + svgComponentName + ".vue").default;
                    this.chapterIconComponent = svgComponentName;
                }
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .chapter-item svg {
        width: 42px;
        height: 42px;

        /*
        fill: $color-brand-primary;
        margin-bottom: 10px;
        */
    }

    .popup-subchapters-symptoms-wrapper svg {
        fill: $color-brand-primary;
        width: 42px;
        height: 42px;
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/ChapterIcon.vue